import { render, staticRenderFns } from "./Title_CustomerGroup.vue?vue&type=template&id=4c99356a&scoped=true&"
import script from "./Title_CustomerGroup.vue?vue&type=script&lang=js&"
export * from "./Title_CustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c99356a",
  null
  
)

export default component.exports